import {Toast} from "primereact/toast";
import {ContainerTitleTable} from "../../../components/Containers/ContainerTitleTable";
import React, {useEffect, useRef, useState} from "react";
import {UsePermissions} from "../../../hooks/usePermissions";
import {ContainerTable} from "../../../components/Containers/ContainerTable";
import {DataTable} from "primereact/datatable";
import {exportExcel} from "../../../shared/utils/utils";
import {getData} from "../../../api/asociadoContrato.service";
import {Column} from "primereact/column";
import {FilterMatchMode, FilterOperator} from "primereact/api";


export const TablaAsociadoContrato = ( {reload, nuevoUsuario, obtenerParametrosUser} ) => {
    const toast = useRef(null);
    const [permisos] = UsePermissions();
    const [expandedRows, setExpandedRows] = useState(null);
    const [loading, setLoading] = useState(false);
    const [totalRecords, setTotalRecords] = useState(0);
    const [rowInit, setrowInit] = useState(50);

    const [compensacion, setCompensacion] = useState([]);

    const initParams= {
        first: 0,
        rows: 10,
        page: 1,
        sortField: null,
        sortOrder: null,
        filters: {
            'cliente': {constraints: [{value: '', matchMode: FilterMatchMode.CONTAINS}]},
        }
    }

    const [lazyParams, setLazyParams] = useState(initParams);

    async function init(datos) {
        const response = await getData(datos);
        const data = await response.data;

        return data.data;
    }

    const loadLazyData = () => {
        setLoading(true);
        init({lazyEvent: lazyParams}).then(data => {
            // record
            setTotalRecords(data.total);
            // total
            setCompensacion(data);
            setLoading(false);
        })
    }

    const onSort = (event) => {
        setLazyParams(event);
    }

    const onPage = (event) => {
        setrowInit(event.rows);
        setLazyParams(event);
    }

    const laziParamsInit = () => {
        setLazyParams(initParams);
    }

    const onFilter = (event) => {
        event['first'] = 0;
        setLazyParams(event);
    }

    useEffect(() => {
        loadLazyData();

        return () => {
            // record
            setTotalRecords(0);
            setCompensacion([]);

        }
    }, [lazyParams])

    useEffect(() => {
        if (reload) {
            loadLazyData();
        }
        return () => {

        }
    }, [reload]);

    const header = (
        <div className="flex align-items-center justify-between">
            <div>
                <h1>Datos Asociados Por Cliente</h1>
            </div>
            <div>
                <button
                    className="secundary-color-btn btn"
                    type="button"
                    disabled={(!permisos.adicionar)}
                    onClick={nuevoUsuario}
                >
                    <i className="fa fa-user"/>
                </button>
            </div>
        </div>
    );

    const actionTemplate = function (rowData) {
        return (
            <div className="flex align-items-center justify-start">
                <button
                    disabled={(!permisos.editar)}
                    className="btn primary-color-btn"
                    type="button"
                    onClick={ () => obtenerParametrosUser(rowData)}
                >
                    <i className="fa fa-user-edit"/>
                </button>
            </div>
        );
    }

    const rowExpansionTemplate = (data) => {
        return (
            <div className="orders-subtable">
                <DataTable showGridlines value={data.asoClientes} responsiveLayout="scroll">
                    <Column header="Gestionar" style={{fontSize: ".8em"}} style={{width:'300px'}} body={actionTemplate}></Column>
                    <Column field="nombre_asociado" header="Asociado" style={{width:'910px'}} filter sortable></Column>
                </DataTable>
            </div>
        );
    }

    return(
        <div className="datatable-rowexpansion-demo">
            <Toast ref={toast} />

            <div className="card">
                <DataTable
                    resizableColumns
                    columnResizeMode="expand"
                    header={header}
                    size="small"
                    showGridlines
                    value={compensacion}
                    scrollable
                    scrollHeight="400px"
                   rowExpansionTemplate={rowExpansionTemplate}
                    expandedRows={expandedRows} onRowToggle={(e) => setExpandedRows(e.data)}
                    responsiveLayout="scroll">
                    <Column expander style={{ width: '40%' }} />
                    <Column style={{width:'60%'}} field="nombre_cliente" filter header="Cliente" sortable />
                </DataTable>
            </div>
        </div>
    )
}
